import { render, staticRenderFns } from "./Reports_Checkstatus_Checkproperties.vue?vue&type=template&id=b88e587e&scoped=true&"
import script from "./Reports_Checkstatus_Checkproperties.vue?vue&type=script&lang=js&"
export * from "./Reports_Checkstatus_Checkproperties.vue?vue&type=script&lang=js&"
import style0 from "./Reports_Checkstatus_Checkproperties.vue?vue&type=style&index=0&id=b88e587e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88e587e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
